"use client";

import {
  SandpackCodeEditor,
  SandpackConsole,
  SandpackFileExplorer,
  SandpackLayout,
  SandpackPreview,
  SandpackProvider,
  SandpackTests,
} from "@codesandbox/sandpack-react";
import { nightOwl } from "@codesandbox/sandpack-themes";
import { Group, Panel, Separator } from "react-resizable-panels";
import type { JavaScriptSandboxData } from "../type";

type JavaScriptSandboxProps = {
  data: JavaScriptSandboxData;
};

export const JavaScriptSandbox: React.FC<JavaScriptSandboxProps> = ({ data }) => {
  const files = data?.files;

  return (
    <SandpackProvider
      files={files}
      theme={nightOwl}
      template={data.template}
      style={{
        width: "100%",
      }}
    >
      <SandpackLayout
        style={{
          width: "100%",
          height: "800px",
          maxHeight: "60vh",
          display: "flex",
        }}
      >
        <SandpackFileExplorer
          style={{
            width: "200px",
            height: "100%",
          }}
        />
        <Group
          orientation="horizontal"
          style={{
            flex: 1,
          }}
        >
          <Panel defaultSize="70%">
            <Group orientation="vertical" style={{ height: "100%" }}>
              <Panel
                defaultSize="80%"
                style={{
                  height: "100%",
                }}
              >
                <SandpackCodeEditor
                  closableTabs
                  showTabs
                  showInlineErrors
                  showLineNumbers
                  style={{
                    height: "100%",
                  }}
                />
              </Panel>
              {data?.shouldShowTests && (
                <>
                  <Separator />
                  <Panel defaultSize="20%">
                    <SandpackTests
                      style={{
                        height: "100%",
                      }}
                    />
                  </Panel>
                </>
              )}
            </Group>
          </Panel>
          {(data?.shouldShowConsole || data?.shouldShowPreview) && (
            <>
              <Separator />
              <Panel defaultSize="30%">
                <Group
                  orientation="vertical"
                  style={{
                    height: "100%",
                  }}
                >
                  {data?.shouldShowPreview && (
                    <Panel defaultSize="50%">
                      <SandpackPreview
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                      />
                    </Panel>
                  )}
                  {(data?.shouldShowConsole || data?.shouldShowPreview) && <Separator />}
                  {data?.shouldShowConsole && (
                    <Panel defaultSize="50%">
                      <SandpackConsole />
                    </Panel>
                  )}
                </Group>
              </Panel>
            </>
          )}
        </Group>
      </SandpackLayout>
    </SandpackProvider>
  );
};
